<template>
  <div style="margin:1%">
    <b-form-group label-align="right" :label="$t('Created on')" disabled label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input v-model="additionalInfo.userCreateDate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Last modified on')" disabled label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input v-model="additionalInfo.userLastChangeDate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Created by')" disabled label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input type="text" v-model="additionalInfo.whoCreate"/>
    </b-form-group>
    <b-form-group label-align="right" :label="$t('Modified by')" disabled label-cols="4" label-cols-xl="2" label-cols-md="4">
        <b-form-input type="text" v-model="additionalInfo.whoChange"/>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: null,
    currentRow: null
  },
  computed: {
    additionalInfo () {
      let tmp = {
        userCreateDate: this.$root.getMomentWithTZDelta(this.userInfo.create_date).format('MM-DD-YYYY'),
        userLastChangeDate: this.$root.getMomentWithTZDelta(this.userInfo.last_change_date).format('MM-DD-YYYY'),
        whoChange: null,
        whoCreate: null
      }
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']))) {
        if (el.user_id === this.userInfo.who_change) {
          tmp.whoChange = el.login + ' (' + el.user_id + ')'
        }
        if (el.user_id === this.userInfo.who_create) {
          tmp.whoCreate = el.login + ' (' + el.user_id + ')'
        }
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additionalInfo/main.vue